import * as api from "@/api/williams/scopesOfWork";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinScope() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());
  });
}
